interface IRenderGroupNameProps {
  name: string;
}

const RenderGroupName = ({ name }: IRenderGroupNameProps) => {
  return <div style={{}}>{name && name}</div>;
};

export default RenderGroupName;
